export const EN_LANG = "en-GB";

export const CACHE_DURATION_MS = window.APP_SETTINGS.localizationCacheDurationSeconds
    ? Number(window.APP_SETTINGS.localizationCacheDurationSeconds) * 1000
    : 60_000;

export const LOAD_RETRY_DELAY = 1000;
export const LOAD_RETRY_COUNT = 10;
